import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { observer } from 'mobx-react';
import BaseGrid from '../common/grid/BaseGrid';
import styled from '@emotion/styled';
import { SystemStatus } from '../../store/models/SystemStatus';
import SystemStatusForm from './SystemStatusForm';
import EditCell from '../common/grid/EditCell';
import { Button, Intent } from '@blueprintjs/core';
import moment from 'moment';

const ButtonsContainer = styled.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  marginBottom: 5,
});

interface PlanningManagerProps extends WithTranslateProps {
  planningSystemStatus: Array<Instance<typeof SystemStatus>>;
  onStatusSave: (data: Instance<typeof SystemStatus>) => void;
  secretariatId: number;
}

interface PlanningManagerState {
  systemStatusEdition?: Instance<typeof SystemStatus>;
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

@observer
class PlanningManager extends React.Component<PlanningManagerProps, PlanningManagerState> {
  state = {
    systemStatusEdition: undefined,
  } as PlanningManagerState;

  columns = [
    { headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_Year), field: 'year', sort: 'desc' },
    { headerName: this.props.translate(TLCode.SECRETARIAT_DASHBOARD_Status), field: 'status' },
    {
      width: 100,
      headerName: '',
      sortable: false,
      filter: false,
      cellRendererFramework: EditCell,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          onEditButtonClick: () => {
            this.startEdition(params.data.id);
          },
        };
      },
    },
  ] as ColDef[];

  buildGridData = () => {
    return this.props.planningSystemStatus.map((ss) => ({
      id: ss.systemStatusId,
      year: ss.year,
      status: ss.status,
    }));
  };

  startEdition = (id: number) => {
    const status = this.props.planningSystemStatus.find((elem) => elem.systemStatusId === id);
    this.setState({ systemStatusEdition: status });
  };

  stopEdition = () => {
    this.setState({ systemStatusEdition: undefined });
  };

  save = (data: Instance<typeof SystemStatus>) => {
    this.props.onStatusSave(data);
    this.stopEdition();
  };

  render() {
    const { systemStatusEdition } = this.state;
    const { translate, secretariatId } = this.props;

    return (
      <Container>
        <ButtonsContainer>
          <Button
            text={translate(TLCode.Add)}
            intent={Intent.PRIMARY}
            onClick={() => {
              this.setState({
                systemStatusEdition: SystemStatus.create({
                  systemStatusId: 0,
                  secretariatId,
                  status: 'UnderConstruction',
                  year: moment().year(),
                  subSystem: 'Planning',
                }),
              });
            }}
          />
        </ButtonsContainer>
        <BaseGrid columnDefs={this.columns} rowData={this.buildGridData()} keyName={'id'} />
        <SystemStatusForm
          systemStatus={systemStatusEdition}
          onSave={this.save}
          onStop={this.stopEdition}
          status={['Closed', 'UnderConstruction', 'Published']}
        />
      </Container>
    );
  }
}

export default withTranslate(PlanningManager);
